var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 405,
    viewBox: "0 0 346 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5112_1658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 346,
    width: 300,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.6 346.329H23V404.604H322.6V346.329Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5112_1658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.666 399.934C243.835 399.934 301.528 342.222 301.528 271.03C301.528 199.838 243.835 142.125 172.666 142.125C101.498 142.125 43.8047 199.838 43.8047 271.03C43.8047 342.222 101.498 399.934 172.666 399.934Z",
    fill: "#FFC289"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 344.248H322.601",
    stroke: "#343239",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.659 1H287.257C306.395 1 321.913 5.72891 321.913 11.5622V168.211C321.913 174.052 306.355 178.784 287.194 178.772L35.5948 178.63C16.4782 178.62 1 173.894 1 168.069V11.5622C1 5.72891 16.5172 1 35.659 1Z",
    fill: "white",
    stroke: "#343239",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4953 70.9464L44.4536 92.7209C44.4224 108.778 58.0028 121.819 74.7858 121.848C91.5694 121.878 105.2 108.885 105.231 92.829L105.273 71.0539L44.4953 70.9464ZM44.5118 62.5058L105.29 62.6133L105.303 55.7252L44.5253 55.6171L44.5118 62.5058ZM43.5613 47.1748C39.23 47.1675 35.7121 50.5201 35.7044 54.6639L35.6309 92.7057C35.5903 113.424 53.1138 130.25 74.7699 130.289C96.4259 130.327 114.014 113.562 114.054 92.8447L114.128 54.8029C114.136 50.6591 110.631 47.2941 106.3 47.2862L43.5613 47.1748ZM92.9822 81.1995L62.2359 110.506L56.7005 105.191L87.4474 75.8847L92.9822 81.1995ZM87.1733 109.445C89.6237 109.449 91.6141 107.552 91.6188 105.207C91.6235 102.863 89.6401 100.958 87.1898 100.954C84.7389 100.95 82.7491 102.847 82.7444 105.192C82.7397 107.536 84.7224 109.44 87.1733 109.445ZM66.7595 81.8691C66.7548 84.2133 64.7644 86.1102 62.3141 86.1063C59.8632 86.1018 57.8804 84.1976 57.8851 81.8533C57.8893 79.5085 59.8796 77.6117 62.3306 77.6162C64.7809 77.6201 66.7636 79.5243 66.7595 81.8691Z",
    fill: "#151418"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.611 91.04H127.98",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287.282 91.04H171.846",
    stroke: "#343239",
    strokeOpacity: 0.26,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.067 108.118C155.696 108.134 148.898 101.36 148.882 92.9894C148.867 84.6185 155.64 77.82 164.011 77.8045C172.382 77.7889 179.181 84.5623 179.196 92.9333C179.212 101.304 172.438 108.103 164.067 108.118Z",
    fill: "white",
    stroke: "#343239",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M311.921 196.035C330.743 190.992 341.912 171.646 336.869 152.824C331.826 134.003 312.479 122.833 293.658 127.876C274.836 132.919 263.666 152.266 268.71 171.087C273.753 189.909 293.099 201.079 311.921 196.035Z",
    fill: "white",
    stroke: "#343239",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M313.693 156.662L313.621 156.265C313.153 153.65 311.596 151.376 309.362 150.046M309.362 150.046L308.808 149.717C306.38 148.272 303.293 148.867 301.536 151.12C299.855 153.279 299.87 156.356 301.567 158.497L305.656 163.651C307.564 166.06 307.339 169.584 305.134 171.711C303.142 173.635 300.166 173.988 297.804 172.582L297.008 172.108M309.362 150.046L312.109 145.14M292.914 165.072L293.003 165.848C293.308 168.469 294.791 170.787 297.008 172.108M297.008 172.108L294.01 177.462",
    stroke: "#343239",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.58fc4f083a86c4399a8a48d537dddce6.svg";
export { ForwardRef as ReactComponent };